import React, { forwardRef, JSX, Ref } from 'react';
import { Button } from 'reactstrap';
import { DateDisplay, Nbsp } from '@ibe/components';
import DataTestIdProp from '../DataTestIdProp';
import { CustomDisplayProps } from './CustomDisplayProps';

const CustomDateDisplayInner = (
  props: CustomDisplayProps & DataTestIdProp,
  ref: Ref<Button>
): JSX.Element => {
  const { onClick, date, format, placeholder, dataTestId, className } = props;
  return (
    <Button
      className={`iso__date-range-input custom-button ${className || ''}`}
      color="white"
      onClick={onClick}
      ref={ref}
      data-testid={dataTestId}
    >
      <div className="d-flex">
        {date ? (
          <div className="w-100">
            <DateDisplay date={date.toISOString()} format={format} />
          </div>
        ) : (
          <Nbsp />
        )}
        {!date && placeholder ? (
          <div className="w-100 text-left text-muted">{placeholder}</div>
        ) : (
          <Nbsp />
        )}
      </div>
    </Button>
  );
};

export const CustomDateDisplay = forwardRef(CustomDateDisplayInner);
